// scroll to tree video section for home
document.addEventListener("DOMContentLoaded", function () {
  const getDevice = () => (window.innerWidth >= 769 ? "desktop" : "mobile");

  const flag = document.querySelector("[data-js-theater-flag]");
  const desktop_section = document.querySelector(".original-tree-section");
  const mobile_section = document.querySelector(".custom-modal-section");

  if (!flag) {
    return console.log("Cant find DOM elements to scroll, home page");
  }

  const is_home = isHomePage();

  if (is_home) {
    const urlParams = new URLSearchParams(window.location.search);
let has_scroll = window.location.search.includes("scroll");

    if (has_scroll) {
      scrollView(getDevice());
    }

    flag.addEventListener("click", () => {
      scrollView(getDevice());
    });
  }

  if (!is_home) {
    console.log("not home");
    flag.addEventListener("click", () => {
      window.location.href = "/?scroll";
    });
  }

  function isHomePage() {
    const currentPath = window.location.pathname;
    return currentPath === "/" || currentPath === "/index.html";
  }

  // util
  function scrollView(type) {
    if (type === "mobile") {
      if (!mobile_section) return console.warn("mobile_section not found");
      mobile_section.scrollIntoView({ behavior: "smooth", block: "nearest" });
    } else if (type === "desktop") {
      if (!desktop_section) return console.warn("desktop_section not found");
      desktop_section.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }
});
